(() => {
	let e = window.Difrax?.sectionLifecycle;
	if (!e) return;
	let t = window.Difrax || {},
		n = `[data-product-slider-recommendations]`,
		r = () => {
			let e = window.Shopify?.routes?.root || `/`;
			return e.endsWith(`/`) ? e : `${e}/`;
		},
		i = (e) => Number(e.dataset.productsPerRowDesktop) || 4,
		a = (e) =>
			typeof e == `function`
				? {
						getInstance(e) {
							return e.swiper || null;
						},
						mount(t, n) {
							return new e(t, n);
						},
						update(e, t) {
							let n = this.getInstance(e);
							return n
								? ((n.params.slidesPerView = t.slidesPerView), n.update(), !0)
								: !1;
						},
						destroy(e) {
							let t = this.getInstance(e);
							t && t.destroy(!0, !0);
						},
					}
				: null,
		o = () => t.productSliderAdapter || a(window.Swiper);
	(t.createSwiperSliderAdapter = a), (window.Difrax = t);
	let s = (e) => {
			let t = e.querySelector(`[data-product-slider-swiper]`);
			if (!t) return;
			let n = o();
			if (
				!(
					e.dataset.enableCarousel === `true` &&
					window.matchMedia(`(min-width: 750px)`).matches
				)
			) {
				n?.destroy?.(t);
				return;
			}
			if (!n) return;
			let r = {
				slidesPerView: i(e),
				spaceBetween: 16,
				watchOverflow: !0,
				keyboard: { enabled: !0, onlyInViewport: !0 },
				navigation: {
					nextEl: e.querySelector(`[data-product-slider-next]`),
					prevEl: e.querySelector(`[data-product-slider-prev]`),
				},
			};
			n.update?.(t, r) || n.mount?.(t, r);
		},
		c = (e, t) => {
			let n = e.dataset.productSliderRecommendationsSectionId,
				i = e.dataset.productSliderRecommendationsProductId;
			if (!n || !i) return null;
			let a = new URL(window.location.href),
				o = new URL(a.href);
			o.pathname = `${r()}recommendations/products`;
			let s = [`preview_theme_id`, `pb`, `key`, `_fd`, `oseid`],
				c = new URLSearchParams();
			for (let e of s) {
				let t = a.searchParams.get(e);
				t && c.set(e, t);
			}
			(o.search = ``),
				c.forEach((e, t) => {
					o.searchParams.set(t, e);
				}),
				o.searchParams.set(`section_id`, n),
				o.searchParams.set(`product_id`, i);
			let l = e.dataset.productSliderRecommendationsLimit;
			l && o.searchParams.set(`limit`, l);
			let u = t || e.dataset.productSliderRecommendationsIntent;
			return u && o.searchParams.set(`intent`, u), o.toString();
		},
		l = (e, t) => {
			e.innerHTML = t.innerHTML;
			for (let { name: n, value: r } of Array.from(t.attributes))
				n === `id` || n === `class` || e.setAttribute(n, r);
			(e.className = t.className),
				e.removeAttribute(`data-product-slider-recommendations`);
		},
		u = async (e) => {
			let t = await fetch(e, {
				credentials: `same-origin`,
				headers: { Accept: `text/html` },
			});
			if (!t.ok) throw Error(`Unable to load recommendations`);
			return t.text();
		},
		d = (e, t) => {
			let r = new DOMParser().parseFromString(e, `text/html`),
				i = r.getElementById(`shopify-section-${t}`);
			if (i) {
				let e = i.querySelector(`[data-product-slider]`);
				if (e) return e;
			}
			let a = r.querySelector(n) || r.querySelector(`[data-product-slider]`);
			if (a) return a;
			let o = document.createElement(`div`);
			return (
				(o.innerHTML = e.trim()),
				o.querySelector(n) || o.querySelector(`[data-product-slider]`)
			);
		},
		f = async (t) => {
			if (t.dataset.productSliderRecommendationsLoaded === `true`) return;
			let n = t.dataset.productSliderRecommendationsSectionId;
			if (!n) return;
			t.dataset.productSliderRecommendationsLoaded = `true`;
			let r = [
				t.dataset.productSliderRecommendationsIntent,
				t.dataset.productSliderRecommendationsIntent === `related`
					? `complementary`
					: `related`,
			].filter(Boolean);
			try {
				let i = null;
				for (let e of r) {
					let r = c(t, e);
					if (
						r &&
						((i = d(await u(r), n)), i?.querySelector(`.product-slider__slide`))
					)
						break;
				}
				if (!i?.querySelector(`.product-slider__slide`)) {
					t.querySelector(
						`[data-product-slider-recommendations-loading]`,
					)?.removeAttribute(`data-product-slider-recommendations-loading`);
					return;
				}
				l(t, i),
					s(t),
					p(t),
					e.runAll?.(t, { reason: `product-slider:recommendations` });
			} catch (e) {
				t
					.querySelector(`[data-product-slider-recommendations-loading]`)
					?.removeAttribute(`data-product-slider-recommendations-loading`),
					console.warn(`Unable to load product slider recommendations`, e);
			}
		},
		p = (e) => {
			e.querySelectorAll(`[data-product-slider-swiper]`).forEach((e) => {
				e.addEventListener(`keydown`, (t) => {
					if ((t.key !== `ArrowLeft` && t.key !== `ArrowRight`) || e.swiper)
						return;
					t.preventDefault();
					let n = t.key === `ArrowRight` ? 1 : -1;
					e.scrollBy({
						left: n * Math.max(160, e.clientWidth * 0.8),
						behavior: `smooth`,
					});
				});
			});
		};
	e.register({
		name: `product-slider`,
		selector: `[data-product-slider]`,
		init(e) {
			if (e.matches(n) && !e.querySelector(`.product-slider__slide`)) {
				f(e);
				return;
			}
			s(e), p(e);
		},
		update(e) {
			s(e);
		},
	});
})();
